import React, { useState } from 'react';
import { DialogTitle, DialogContent, DialogActions, Typography } from '@material-ui/core';
import { useMutation } from '@apollo/client';
import * as Sentry from '@sentry/react';
import { PrimaryButton, SecondaryButton } from '@/styles/blocks';
import NavResponsiveModal from '@/components/Navigation/NavResponsiveModal';
import RescheduleReasonFields from '@/components/Reschedule/RescheduleReasonFields';
import { buildReschedulePatch, isRescheduleReasonValid } from '@/components/Reschedule/utils';
import { UPDATE_ACTIVITY_LOG_REASON } from './graphql';

// Add or correct the reschedule reason on a scheduling log after the fact. The log's note is the
// reschedule notes copied off the order at the time, so it's edited with the same fields.
export default function EditRescheduleReasonModal({ log, onClose }) {
    const [reason, setReason] = useState(log.reschedule_reason_code || '');
    const [notes, setNotes] = useState(log.log_detail || '');
    const [error, setError] = useState(null);

    const [updateLog, { loading }] = useMutation(UPDATE_ACTIVITY_LOG_REASON);

    const isValid = isRescheduleReasonValid({ reason, notes });

    const handleSave = () => {
        const { reschedule_reason_code, reschedule_reason_notes } = buildReschedulePatch({ reason, notes });
        setError(null);
        updateLog({
            variables: { log_id: log.log_id, reschedule_reason_code, log_detail: reschedule_reason_notes },
        })
            .then(onClose)
            .catch((e) => {
                Sentry.captureException(e);
                setError('Could not save the reschedule reason. Please try again.');
            });
    };

    return (
        <NavResponsiveModal open onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle>Edit Reschedule Reason</DialogTitle>
            <DialogContent>
                <RescheduleReasonFields
                    reason={reason}
                    notes={notes}
                    onChangeReason={setReason}
                    onChangeNotes={setNotes}
                    disabled={loading}
                />
                {error && (
                    <Typography color="error" variant="body2" style={{ marginTop: '12px' }}>
                        {error}
                    </Typography>
                )}
            </DialogContent>
            <DialogActions style={{ justifyContent: 'space-between', padding: '16px 24px' }}>
                <SecondaryButton disabled={loading} onClick={onClose}>
                    Cancel
                </SecondaryButton>
                <PrimaryButton disabled={loading || !isValid} onClick={handleSave}>
                    Save
                </PrimaryButton>
            </DialogActions>
        </NavResponsiveModal>
    );
}
